module.exports = __webpack_public_path__ + "img/2-1.77419b7c.svg";